import api from "./api";

export function fnShowAutomationTutorial() {
    const response = api.get("/op-panel/automation/user_tutorial")
    return response
}

export function fnChangeShowAutomationTutorial() {
    const response = api.post("/op-panel/automation/user_tutorial")
    return response
}

export function fnCreateNewAutomation(data) {
    const response = api.post("/op-panel/automation", data)
    return response
}
export function fnListAutomation(boardId) {
    const response = api.get(`/op-panel/automation/${boardId}/list`)
    return response
}
export function fnGetAutomationData(automationId) {
    const response = api.get(`/op-panel/automation/${automationId}`)
    return response
}
export function fnUpdateAutomation(automationId, data) {
    const response = api.put(`/op-panel/automation/${automationId}`, data)
    return response
}
export function fnGetAutomationActivities(automationId) {
    const response = api.get(`/op-panel/automation/${automationId}/activities`)
    return response
}
export function fnDeleteAutomation(automationId, cPassword) {
    const response = api.delete(`/op-panel/automation/${automationId}`, { data: cPassword })
    return response
}
export function fnInactiveAutomation(automationId) {
    const response = api.patch(`/op-panel/automation/${automationId}/inactivate`)
    return response
}

export function fnAutomationHistory(automationId) {
    const response = api.get(`/op-panel/history?target_ctype=automation&target_nid=${automationId}`)
    return response
}